
import React from 'react';
import { LayoutEnum } from 'src/layouts/constants';
import { BaseResponseType } from 'src/types/base.type';
import { OrganizationType } from 'src/types/organization.type';

type guardedRouteTypes = {
   path: string;
   userRole: string;
};

type routeType = {
   component?: any;
   description?: string;
   /** Routes that share the same `group` key skip the page transition animation when navigating between each other. */
   group?: string;
   layout?: LayoutEnum | string;
   path?: string;
   permissions?: string[];
   roles?: [any];
   title?: string;
   type?: string;
};

type headerType = {
   authorization?: boolean;
   'Content-Length'?: any;
};

export enum PortalEnum {
   Admin = 'admin',
   Web = 'web',
}

type queryFilter = {
   limit?: number;
   page?: number;
   searchQuery?: string;
   sortBy?: string;
   sortByType?: string;
   type?: string;
   isFetchAllSites?: boolean;
};

type queryEventFilter = queryFilter & {
   organizationId?: string;
};

type fieldFilter = {
   fields?: string[];
   isFetchAllSites?: boolean;
   /** NPT-1551: only organizations that have at least one child ("clubs"). Resolved server-side. */
   hasChildren?: boolean;
};

type queryUserOrganizationFilter = {
   searchQuery?: string;
   page?: number;
   limit?: number;
};

type propsBasicLayoutType = {
   backgroundUrl?: string;
   children?: React.ReactNode;
};

type propsMainLayoutType = {
   children?: React.ReactNode;
   type?: any;
   permissions?: any;
   path?: any;
};

type UserType = BaseResponseType & {
   address?: string;
   address2?: string;
   birthdate?: string;
   city?: string;
   country?: string;
   emailAddress: string;
   emailVerified: boolean;
   fileImage?: any;
   firstName?: string;
   gender?: string;
   isActive: boolean;
   lastLogin?: Date;
   lastName?: string;
   organizations?: Array<OrganizationType>;
   phoneNumber?: string;
   postcode?: string;
   roles: Array<RoleType>;
   state?: string;
   originalOrganization?: OrganizationType;
};

type uploadImageTypes = {
   handleUploadImage: (file: File) => void;
   handleRemoveImage: () => void;
   imgUrl?: string;
};

type orgTypes = {
   id: string;
   name: string;
   userOrganizations: any;
   status?: string;
   isActive?: boolean;
};

type selectPropsType = {
   id: string | undefined;
   label: string;
   options: Array<Record<string, unknown>> | undefined;
   selected: string;
   onChange: (value: string) => void;
};

type paginateType = {
   setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
   currentPage: number;
   totalEntities: number;
   isLoadingTable?: boolean;
   exportHandler?: () => void;
   pageCount: number;
   setPageCount: React.Dispatch<React.SetStateAction<number>>;
   isShowDownload?: boolean;
};

type permissionType = {
   id: string;
   key: string;
   label: string;
   isChecked: boolean;
};

type RoleType = {
   id: string;
   created: string;
   modified: string;
   deleted: string;
   displayName: string;
   type: string;
   description: string;
   permissions?: permissionType[] | string[];
};

type myTokenType = {
   token: string;
   expiredDate: string;
   status: string;
};

export enum GlobalConfigType {
   GLOBAL = 'global',
}
export type {
   fieldFilter,
   guardedRouteTypes,
   headerType,
   myTokenType,
   orgTypes,
   paginateType,
   propsBasicLayoutType,
   propsMainLayoutType,
   queryFilter,
   queryEventFilter,
   queryUserOrganizationFilter,
   RoleType,
   routeType,
   selectPropsType,
   uploadImageTypes,
   UserType,
};
